<div class="risk-gauge" #gauge>
  <svg viewBox="0 0 200 120" class="risk-gauge__svg" (mousemove)="onZoneMove($event)">
    <!-- Coloured zones. Hover shows the count and moves the needle to the zone. -->
    <path
      [attr.d]="greenArc"
      [attr.stroke]="greenColor"
      class="risk-gauge__arc"
      (mouseenter)="onZoneEnter('LOW')"
      (mouseleave)="onZoneLeave()"
    ></path>
    <path
      [attr.d]="yellowArc"
      [attr.stroke]="yellowColor"
      class="risk-gauge__arc"
      (mouseenter)="onZoneEnter('MEDIUM')"
      (mouseleave)="onZoneLeave()"
    ></path>
    <path
      [attr.d]="redArc"
      [attr.stroke]="redColor"
      class="risk-gauge__arc"
      (mouseenter)="onZoneEnter('HIGH')"
      (mouseleave)="onZoneLeave()"
    ></path>

    <!-- Needle -->
    <line
      *ngIf="hasData"
      [attr.x1]="cx"
      [attr.y1]="cy"
      [attr.x2]="needleX"
      [attr.y2]="needleY"
      class="risk-gauge__needle"
    />
    <circle [attr.cx]="cx" [attr.cy]="cy" r="5" class="risk-gauge__hub" />
  </svg>

  <div class="risk-gauge__legend" *ngIf="hasData; else noData">
    <span class="risk-gauge__legend-item">
      <span class="risk-gauge__dot" [style.background]="greenColor"></span>
      <span translate>LOW</span>: {{ lowCount }}
    </span>
    <span class="risk-gauge__legend-item">
      <span class="risk-gauge__dot" [style.background]="yellowColor"></span>
      <span translate>MEDIUM</span>: {{ mediumCount }}
    </span>
    <span class="risk-gauge__legend-item">
      <span class="risk-gauge__dot" [style.background]="redColor"></span>
      <span translate>HIGH</span>: {{ highCount }}
    </span>
  </div>
  <ng-template #noData>
    <div class="risk-gauge__legend">
      <span translate>NO_RECORDS_FOUND</span>
    </div>
  </ng-template>

  <div
    class="risk-gauge__tooltip"
    *ngIf="tipVisible"
    [style.left.px]="tipX"
    [style.top.px]="tipY"
  >
    {{ tipZoneKey | translate }}: {{ tipCount }}
  </div>
</div>
